import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SignupHomeStore {

}

export enum SignupHomeStoreKeys {

}
